module.exports = __webpack_public_path__ + "img/face-0.b5698bd3.png";